<div class="card-white noMarginMovil sumaryContainer">
  <div class="titleSumary blue-dark flex-container-nowrap w-100">
    {{ 'k002785' | translate }}
    <!-- Token: Costes en un escenario promedio -->
    <fa-icon
      class="font-15 ml-2 blue2 pointer"
      icon="info-circle"
      (click)="viewHintHelp($event)"
    ></fa-icon>
  </div>
  <div class="initial-Periodic">
    <span class="spanFeedVoid"></span>
    <div class="averageLabel blue-dark">
      {{ 'k000097' | translate }}
      <!-- token: Porcentaje (%) -->
    </div>
    <div class="inTermsLabel blue-dark">{{ inAmount }}</div>
    <!-- token: In amount ({0}) -->

    <span class="labelInitial">{{ feeOf }}</span>
    <!-- token: {0} Fee -->
    <span class="averageData">{{ averageDataWealth | trPercent }}</span>
    <span class="intermsData">{{ inTermsWealth | trCurrency : currency }}</span>

    <span class="labelInitial">{{ 'k002450' | translate }}</span>
    <!-- token: Avarage Funds Costs -->
    <span class="averageData">{{ averageData | trPercent }}</span>
    <span class="intermsData">{{ inTerms | trCurrency : currency }}</span>
  </div>
  <div class="totalFeesData">
    <div class="totalLabel">
      {{ 'k000453' | translate }}
      <!-- token: Total -->
    </div>
    <span class="averageData">{{ averageTotal | trPercent }}</span>
    <span class="averageData">{{ inTermsTotal | trCurrency : currency }}</span>
    <!-- token: Average -->
  </div>
  <div class="feesInfo w-100 mt-4">
    {{ feesInfo }}
  </div>
  <!-- Token: "Approximately the cost of the whole investing in a fully managed portfolio
    with WealthRules. Estimated cost of investing over the next 12 months" -->
</div>
